import { connect } from 'react-redux';
import { State } from 'store/types';

import {
  fetchAuth,
  fetchUserHash,
  fetchPriveTier,
} from 'shared/store/auth/action';
import {
  fetchConfigFlags,
  fetchGeoSubdivision,
} from 'shared/store/app/actions';
import { getMobileMappingStatus } from 'User/store/mobileVerification/actions/mobileMappingStatus';

import View from './View';
import { isEligible } from 'store/app/selector';
import { showSignUp, showProfile } from 'shared/store/app/actions';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { USER_SEGMENT_EXP } from 'constants/experiments';

const mapDispatchToProps = {
  fetchAuth,
  fetchPriveTier,
  fetchUserHash,
  fetchConfigFlags,
  fetchGeoSubdivision,
  suggestMobile: getMobileMappingStatus,
  showSignUp,
  showProfile,
};

const mapStateToProps = (state: State) => {
  const {
    auth: { user, dataFetched, fetchedOverNetwork },
    appReducer: {
      storeId,
      configFlagsFetched,
      configFlags,
      geoSubdivisionFetched,
      geoSubdivision,
      run,
      vrnRegionEligibility,
      region,
    },
    remoteConfig,
  } = state;

  return {
    user,
    configFlags,
    configFlagsFetched,
    geoSubdivision,
    geoSubdivisionFetched,
    email: user.email,
    firstName: user.firstName,
    userName: user.userName,
    id: user.id,
    dataFetched,
    fetchedOverNetwork,
    formKey: user.formKey,
    storeId,
    groupId: user.groupId,
    priveBand: user?.priveBand,
    isPro: user.isPro,
    isStoreEnabled: remoteConfig.configs.storeOptions.status,
    trackDeviceId: remoteConfig.switches.trackDeviceId,
    isSuggestedMobileMap: remoteConfig.switches?.suggestMobileMap,
    vrnRegionEligibility,
    vrnExpState: region?.regionHeader,
    domains: remoteConfig.configs.domains,
    isAutoSignUp: isEligible(remoteConfig.configs?.AB?.autoFillSignUp, run),
    isPDPBannerShown: isEligible(remoteConfig.configs?.AB?.pdpBanner, run),
    productId: state.productPage?.product?.id,
    showChatNow: remoteConfig.switches?.showChatNow,
    bucketId: remoteConfig.configs.priceReveal?.data?.bucket || '',
    isPricesRevealedActive: remoteConfig.configs.priceReveal?.active,
    userSegmentConfig: remoteConfig.configs?.userSegmentConfig,
    isUserSegmentEnabled: getEligibleForVariant(state, USER_SEGMENT_EXP, 'A'),
    isDifferentialPricingEnabled:
      remoteConfig.switches.differentialPricingEnabled,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
